import React                             from "react";
import ReactDOM                          from "react-dom";
import { BrowserRouter, Route, Switch }  from "react-router-dom";
//Image LightBox
import SimpleReactLightbox               from 'simple-react-lightbox'
//Layout default import from components.
import defaultLayout                    from "./components/layouts/main";
//Import wrapping layout
import Layout                           from "./components/app";
//Import all page from components
import aboutUs                          from "./components/pages/about-us/AboutUs";
import destinations                     from "./components/pages/destinations/Destinations";
import packages                         from "./components/pages/package/Packages";
import contact                          from "./components/pages/contact/Contact";
import faq                              from "./components/pages/faq/Faq";
import error                            from "./components/pages/404/404";
import guide                            from "./components/pages/guide/GuideComponent";
import gallary                          from "./components/pages/gallary/GalleryComponent";
import packageSidebar                   from "./components/pages/package/PackageSidebar";
import packageStandard                  from "./components/pages/package/PackageStanderd";
import packageDetails                   from "./components/pages/package/PackageDetails";
import Pachacamac                       from "./components/pages/package/pachacamac";
import LimaBohemian                     from "./components/pages/package/lima_bohemian";
import Limabahia                        from "./components/pages/package/limia_bahia";
import CentroHistorico                  from "./components/pages/package/centro_turistico";
import CentralAndes1                    from "./components/pages/package/central_andes_1";
import CentralAndes2                    from "./components/pages/package/central_andes_2";
import AndesALaCosta                    from "./components/pages/package/andes_a_la_costa";
import AndesALaSelva                    from "./components/pages/package/andes_a_la_selva";
import blog                             from "./components/pages/blog/BlogComponent";
import blogSidebar                      from "./components/pages/blog/BlogSidebar";
import blogStandard                     from "./components/pages/blog/BlogStandard";
import blogDetails                      from "./components/pages/blog/BlogDetails";
//Initializations All Css
import './index.css';
import './index.scss';
//Default Warniing Error Hide
console.log = console.warn = console.error = () => {};

/*
* Version : 0.1
* Event : Rendering all content to web.
* Actions: Define all routes and page.
* @return html
* */

class Root extends React.Component{
    render(){
        return(
            <BrowserRouter basename={"/"}>
                    <Switch>
                        <Route exact path='/' component={defaultLayout} />
                        <Layout>
                            <Route path={`${process.env.PUBLIC_URL}/about-us`} component={aboutUs} />
                            <Route path={`${process.env.PUBLIC_URL}/destination`} component={destinations} />
                            <Route path={`${process.env.PUBLIC_URL}/package`} component={packages} />
                            <Route path={`${process.env.PUBLIC_URL}/package-sidebar`} component={packageSidebar} />
                            <Route path={`${process.env.PUBLIC_URL}/package-standard`} component={packageStandard} />
                            <Route path={`${process.env.PUBLIC_URL}/package-details`} component={packageDetails} />
                            <Route path={`${process.env.PUBLIC_URL}/pachacamac`} component={Pachacamac} />
                            <Route path={`${process.env.PUBLIC_URL}/centro_historico`} component={CentroHistorico} />
                            <Route path={`${process.env.PUBLIC_URL}/lima_bahia`} component={Limabahia} />
                            <Route path={`${process.env.PUBLIC_URL}/lima_bohemian`} component={LimaBohemian} />
                            <Route path={`${process.env.PUBLIC_URL}/central_andes`} component={CentralAndes1} />
                            <Route path={`${process.env.PUBLIC_URL}/central_andes_2`} component={CentralAndes2} />
                            <Route path={`${process.env.PUBLIC_URL}/andes_a_la_selva`} component={AndesALaSelva} />
                            <Route path={`${process.env.PUBLIC_URL}/andes_a_la_costa`} component={AndesALaCosta} />
                            <Route path={`${process.env.PUBLIC_URL}/faq`} component={faq} />
                            <Route path={`${process.env.PUBLIC_URL}/404`} component={error} />
                            <Route path={`${process.env.PUBLIC_URL}/guide`} component={guide} />
                            <Route path={`${process.env.PUBLIC_URL}/gallary`} component={gallary} />
                            <Route path={`${process.env.PUBLIC_URL}/blog`} component={blog} />
                            <Route path={`${process.env.PUBLIC_URL}/blog-sidebar`} component={blogSidebar} />
                            <Route path={`${process.env.PUBLIC_URL}/blog-standard`} component={blogStandard} />
                            <Route path={`${process.env.PUBLIC_URL}/blog-details`} component={blogDetails} />
                            <Route path={`${process.env.PUBLIC_URL}/contact`} component={contact} />
                        </Layout>
                    </Switch>
            </BrowserRouter>
        );
    }
}

ReactDOM.render(
    <React.StrictMode>
        <SimpleReactLightbox>
            <Root />
        </SimpleReactLightbox>
    </React.StrictMode>,
    document.getElementById("root")
);

